import { render, staticRenderFns } from "./FaqItems.vue?vue&type=template&id=6505719c&scoped=true&"
import script from "./FaqItems.vue?vue&type=script&lang=js&"
export * from "./FaqItems.vue?vue&type=script&lang=js&"
import style0 from "./FaqItems.vue?vue&type=style&index=0&id=6505719c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6505719c",
  null
  
)

export default component.exports